"use client";

import styles from "./AuthorizeSpinner.module.scss";
import {
  Flex,
  Spinner,
} from "@vetty/ui";

/**
 * AuthorizeSpinner Component
 *
 * A component that displays a spinner while the user is authenticating.
 */
export const AuthorizeSpinner = () => {
  return (
    <Flex className={styles["comp"]} align={"center"} justify={"center"}>
      <Spinner />
    </Flex>
  );
};
